import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { type IOrderNotification } from '@/types/INotification';
import { OrderToastCard } from '../OrderToastCard/OrderToastCard';
import { getNewOrdersLabel } from '@/utils/getNewOrdersLabel';
import { TOAST_VARIANTS, TOAST_TRANSITION } from '../../toastMotion';
import styles from './collapsedOrdersToast.module.scss';

interface ICollapsedOrdersToastProps {
  notifications: IOrderNotification[];
  isExpanded: boolean;
  onToggle: (expanded: boolean) => void;
  onNavigate: (path: string) => void;
  onClose: (id: string) => void;
  onCloseAll: () => void;
}

export const CollapsedOrdersToast: React.FC<ICollapsedOrdersToastProps> = ({
  notifications,
  isExpanded,
  onToggle,
  onNavigate,
  onClose,
  onCloseAll
}) => {
  const count = notifications.length;

  return (
    <motion.div
      layout
      variants={TOAST_VARIANTS}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={TOAST_TRANSITION}
      className={styles['collapsed-orders']}
    >
      <div className={styles['collapsed-orders__header']}>
        <button
          type="button"
          className={styles['collapsed-orders__summary']}
          onClick={() => {
            onToggle(!isExpanded);
          }}
        >
          <span className={styles['collapsed-orders__count']}>{count}</span>
          <span className={styles['collapsed-orders__text']}>
            {getNewOrdersLabel(count)}
          </span>
          <span
            className={cn(styles['collapsed-orders__chevron'], {
              [styles['collapsed-orders__chevron_up']]: isExpanded
            })}
          >
            ▾
          </span>
        </button>
        <button
          type="button"
          className={styles['collapsed-orders__close-all']}
          onClick={onCloseAll}
          aria-label="Закрыть все уведомления"
        >
          ×
        </button>
      </div>

      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            className={styles['collapsed-orders__list']}
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={TOAST_TRANSITION}
          >
            <AnimatePresence initial={false}>
              {notifications.map((notification) => (
                <OrderToastCard
                  key={notification.id}
                  notification={notification}
                  onNavigate={onNavigate}
                  onClose={onClose}
                  autoClose={false}
                  disableLayout
                />
              ))}
            </AnimatePresence>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};
